import {
  GET_USER,
  LIST_USER,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  LOGOUT_USER_SUCCESS,
} from "../actions/types";

const initialState = {
  user: null,
  users: {
    count: 0,
    rows: [],
  },
  login: {
    data: null,
    error: null,
  },
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      return { ...state, user: action.payload, users: initialState.users };
    case LIST_USER:
      return { ...state, users: action.payload, user: initialState.user };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        login: {
          data: action.payload,
        },
      };
    case LOGIN_USER_FAILURE:
    case LOGOUT_USER_FAILURE:
      return {
        ...state,
        login: {
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default users;
